export const UPDATE_APP_SETUP = "UPDATE_APP_SETUP";
export const SET_NAME = "SET_NAME";

export const SET_USER = "SET_USER";

export const UPDATE_FORM_DATA = "UPDATE_FORM_DATA";
export const UPDATE_SYSTEM_MODULES_PERMISSION = "UPDATE_SYSTEM_MODULES_PERMISSION";

export const SERVER_VALIDATION_ERROR = "SERVER_VALIDATION_ERROR";
export const SUBMIT_IS_LOADING = "SUBMIT_IS_LOADING";